
import Image from 'next/image';
import { cn } from '@/lib/utils';

// Props for the AppLogo component.
// We allow overriding width and height, but provide sensible defaults.
interface AppLogoProps {
  className?: string;
  width?: number;
  height?: number;
  // Allow any other props that next/image might accept, except src and alt
  [key: string]: any;
}

export default function AppLogo({ className, width = 120, height = 32, ...props }: AppLogoProps) {
  // Usar la URL directa de Google Drive para el logo
  const logoSrc = "/medicina.png";
  const altText = "Medicina Por Europa Logo";

  return (
    <Image
      src={logoSrc}
      alt={altText}
      width={width}
      height={height}
      className={cn(className)} // Pasa cualquier clase adicional
      data-ai-hint="medical education crest"
      priority={true} // Added priority prop for LCP optimization
      // Considera añadir 'priority' si el logo es un elemento LCP (Largest Contentful Paint)
      {...props} // Pasa otras props de imagen si se especifican
    />
  );
}
